import React from 'react';
import PropTypes from 'prop-types';

import { Decline } from 'components/Icons';
import useWorkflowGuard from 'hooks/useWorkflowGuard';

const KBAFailure = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <Decline className="mb-4" />
      <p className="text-xl md:text-3xl font-semibold text-slate-800 mb-8">
        Unable to Sign Loan<br className="hidden md:block" /> Agreement
      </p>

      <p className="text-sm md:text-base text-gray-600 px-0 md:px-[115px] ">
        Sorry, we were unable to confirm your identity. Call <a href="tel:+18182000238" className="whitespace-nowrap text-blue-500 font-semibold">818-200-0238</a> to continue signing the loan agreement.
      </p>
    </div>
  );
};

KBAFailure.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default KBAFailure;
